import { render } from "./JoinComplete.vue?vue&type=template&id=c21b318a&scoped=true"
import script from "./JoinComplete.vue?vue&type=script&lang=js"
export * from "./JoinComplete.vue?vue&type=script&lang=js"

import "@/styles/header.css?vue&type=style&index=0&id=c21b318a&scoped=true&lang=css&external"
import "@/styles/common.css?vue&type=style&index=1&id=c21b318a&scoped=true&lang=css&external"
import "@/styles/subcommon.css?vue&type=style&index=2&id=c21b318a&scoped=true&lang=css&external"

import exportComponent from "../../../../../../Users/cole/Desktop/중요/tcd-userpage-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c21b318a"]])

export default __exports__